import React, { useState } from 'react';
import AdminSubPage from '../components/AdminSubPage';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const ProvisioningPage = () => {
  const [form, setForm] = useState({ date: '', criteria: 'standard' });
  const [results, setResults] = useState([]);
  const [ran, setRan] = useState(false);

  const handleRun = (e) => {
    e.preventDefault();
    setResults([
      { category: 'Current (0-30 days)', percentage: 1, provision: 12500 },
      { category: 'Watch (31-60 days)', percentage: 5, provision: 8750 },
      { category: 'Substandard (61-90 days)', percentage: 20, provision: 15000 },
      { category: 'Doubtful (91-180 days)', percentage: 50, provision: 22500 },
      { category: 'Loss (180+ days)', percentage: 100, provision: 5000 },
    ]);
    setRan(true);
    toast.success('Provisioning entries calculated');
  };

  return (
    <AdminSubPage title="Provisioning Entries" breadcrumb={['Accounting', 'Provisioning Entries']} backPath="/dashboard/accounting">
      <form onSubmit={handleRun} className="bg-white border border-gray-200 p-6 max-w-md space-y-4 mb-6">
        <p className="text-sm text-gray-500">Create loan loss provisioning entries based on portfolio aging.</p>
        <div><Label>Provisioning Date *</Label><Input type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})} required data-testid="prov-date" /></div>
        <Button type="submit" className="bg-[#1f1f1f] text-white" data-testid="prov-submit">Create Provisioning Entries</Button>
      </form>
      {ran && (
        <div className="bg-white border border-gray-200">
          <table className="w-full">
            <thead><tr className="bg-gray-50 border-b">
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Category</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Percentage</th>
              <th className="text-left px-4 py-3 text-xs font-semibold uppercase tracking-wider text-gray-500">Provision Amount</th>
            </tr></thead>
            <tbody>{results.map((r, i) => (
              <tr key={i} className="border-b">
                <td className="px-4 py-3 text-sm font-medium text-[#1f1f1f]">{r.category}</td>
                <td className="px-4 py-3 text-sm">{r.percentage}%</td>
                <td className="px-4 py-3 text-sm font-medium">R {r.provision?.toLocaleString()}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </AdminSubPage>
  );
};
export default ProvisioningPage;
